import React, { useEffect, useState } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import { useHistory } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import "./Footer.css";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  const history = useHistory();

  const [rainDrops, setRainDrops] = useState<JSX.Element[]>([]);

  useEffect(() => {
    const newRainDrops: JSX.Element[] = [];
    for (let i = 0; i < 50; i++) {
      const style = {
        left: `${Math.random() * window.innerWidth}px`,
        animationDelay: `${Math.random() * 2}s`,
        animationDuration: `${0.5 + Math.random()}s`,
      };
      newRainDrops.push(<div key={i} className="drop" style={style}></div>);
    }
    setRainDrops(newRainDrops);
  }, []);

  const openInNewTab = () => {
    window.open(
      "https://www.google.com/maps/place/18.762636,73.522672",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const webstyle = {
    ulcontent: {
      display: "flex",
      alignItems: "start",
      lineHeight: "1.5",
    },

    footer: {
      display: "flex",
      justifyContent: "space-around",
      backgroundColor: "#12151c",
      color: "white",
      bottom: "0px",
      width: "100%",
      paddingBottom: "16px",
      paddingTop: "25px",
    },
  };
  useGSAP(() => {
    const footerSection = gsap.from(".gsapFooterSection", {
      opacity: 0,
      duration: 1,
      scale: 0.5,
      y: 20,
      delay: 1,
      scrollTrigger: {
        trigger: ".gsapFooterSection",
        scroller: "body",
        markers: false,
        start: "top 100%",
      },
    });

    const footerSection2 = gsap.from(".gsapFooterSection2", {
      opacity: 0,
      duration: 1,
      x: -500,
      scrollTrigger: {
        trigger: ".gsapFooterSection2",
        scroller: "body",
        markers: false,
        start: "top 100%",
      },
    });

    ScrollTrigger.matchMedia({
      "(max-width: 800px)": function () {
        footerSection.vars.scale = 1;
        footerSection.vars.y = 0;
        footerSection2.vars.x = 0;
      },
    });
  });
  return (
    <div style={{  backgroundColor: "#12151c",}} className="Footer">

      <footer
        className="Footer gsapFooterSection2"
        style={{ ...webstyle.footer, textAlign: "center" }}
      >
        <div
          className="FooterSection"
          style={{
            display: "flex",
            flexDirection: "column",
            lineHeight: "2",
            alignItems: "flex-start",
          }}
        >
          <span style={{ color: "white", fontSize: "25px" }}>
            Amenities & Sevices
          </span>
          <a
            href="/coupleroom"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>Couple Room </span>
          </a>
          <a
            href="/familyroompage"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>Family Room </span>
          </a>
          <a
            href="/honeymoonpage"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>HoneyMoon Room </span>
          </a>
          <a
            href="/roomswimpage"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>Room With Swimming pool </span>
          </a>
          <a
            href="/grouproompage"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>Group Room </span>
          </a>
        </div>
        <div
          className="FooterSection"
          style={{
            display: "flex",
            flexDirection: "column",
            lineHeight: "2",
            alignItems: "flex-start",
          }}
        >
          <span style={{ color: "white", fontSize: "25px" }}>NearBy Places</span>
          <a
            href="https://www.google.com/maps/search/wet+n+joy/@18.7558274,73.4915343,13.97z?entry=ttu"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none", color: "white" }}
          >
            {" "}
            <span>Wet n Joy </span>
          </a>
  
          <a
            href="https://www.google.com/maps/place/Bhushi+dam/@18.7227373,73.39168,17z/data=!3m1!4b1!4m6!3m5!1s0x3be8010717b4b8ef:0x9f74dc030691dc4f!8m2!3d18.7227323!4d73.3965509!16s%2Fg%2F11s6vmyy9s?entry=ttu"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none", color: "white" }}
          >
            {" "}
            <span>Bhushi Dam</span>
          </a>
  
          <a
            href="https://www.google.com/maps/place/Tiger+Point+Lonavala/@18.696092,73.3826601,17z/data=!3m1!4b1!4m6!3m5!1s0x3be803ec63c748df:0xb440dcf326c3e04a!8m2!3d18.6960869!4d73.385235!16s%2Fg%2F11g8yj76ch?entry=ttu"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none", color: "white" }}
          >
            {" "}
            <span> Tiger Point</span>
          </a>
  
          <a
            href="https://www.google.com/maps/place/Lonavala,+Maharashtra/@18.7574426,73.3705229,13z/data=!3m1!4b1!4m6!3m5!1s0x3be801098bdf8145:0x696b4a60a5e28658!8m2!3d18.7557237!4d73.4090757!16zL20vMDM4ZDR6?entry=ttu"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none", color: "white" }}
          >
            {" "}
            <span>Lonavla Lake </span>
          </a>
  
          <a
            href="https://www.google.com/maps/place/Kune+Falls/@18.7638061,73.3735268,17z/data=!3m1!4b1!4m6!3m5!1s0x3be8012814e0a799:0x8d298bee3d26ca7d!8m2!3d18.763801!4d73.3761017!16s%2Fm%2F0ch1nrj?entry=ttu"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none", color: "white" }}
          >
            {" "}
            <span>Kune Waterfalls</span>
          </a>
        </div>
        <div
          className="FooterSection"
          style={{
            display: "flex",
            flexDirection: "column",
            lineHeight: "2",
            alignItems: "flex-start",
          }}
        >
          <span style={{ color: "white", fontSize: "25px" }}>Other Links</span>
          <a
            href="/"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>Home</span>
          </a>
          <a
            href="#Nearby"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>NearBy</span>
          </a>
          <a
            href="#Gallery"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>Gallery</span>
          </a>
          <a
            href="#About"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>About</span>
          </a>
          <a
            href="#Contact"
            onClick={() => history.push("/")}
            style={{ textDecoration: "none", color: "white" }}
          >
            <span>ContactUs</span>
          </a>
        </div>
        <div className="map-container">
          <div className="map-overlay" onClick={openInNewTab}></div>
          <iframe
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAAdnoL9ZLaHUAZQ0z1QDjgQWXJCkFlCuE&q=18.762636,73.522672"
            width="100%"
            height="200px"
            style={{ border: 0, borderRadius: "5px" }}
            loading="lazy"
            title="Google Map"
          ></iframe>
        </div>
  
        <div
          className="map_info"
          style={{
            display: "flex",
            flexDirection: "column",
            lineHeight: "2",
            alignItems: "center",
          }}
        >
          <a style={{ textDecoration: "none" }}>
            <div style={{ width: "200px" }}>
              <p style={{ color: "white", fontSize: "25px" }}>Location </p>
              <LocationOnIcon
                className="locationicon"
                sx={{ color: "white", fontSize: "25px", marginTop: "6px" }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={openInNewTab}
              >
                <p
                  style={{ color: "white", margin: "2px 0px", fontSize: "16px" }}
                >
                  Mumbai Pune Highway, Mundhavare, Mawal-410405{" "}
                </p>
              </div>
            </div>
          </a>
        </div>
        <div
          className="iconlink"
          style={{ display: "flex", alignItems: "center", height: "200px" }}
        >
          <a
            href="https://www.instagram.com/eagle_farmhouse_lonavala/?igsh=MnJwN2JqaHJxbm8x&utm_source=qr#"
            target="_blank"
          >
            <InstagramIcon
              sx={{
                fontSize: 40,
                margin: "5px",
                color: "white",
                background:
                  "linear-gradient(to right, #FFD300, #C13584, #E1306C, #833AB4, #5851DB, #4B9CD3)",
                borderRadius: "10px",
                "&:hover": {
                  backgroundColor: "white",
                  cursor: "pointer",
                  borderRadius: "10px",
                  border: "1px solid black",
                },
              }}
            />
          </a>
          <a
            href="https://wa.me/9834986689"
            className="whatsapp-link"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "white" }}
          >
            <WhatsAppIcon
              sx={{
                fontSize: 40,
                margin: "5px",
                color: "white",
                backgroundColor: "green",
                borderRadius: "10px",
                "&:hover": {
                  color: "green",
                  backgroundColor: "white",
                  cursor: "pointer",
                  borderRadius: "10px",
                  border: "1px solid black",
                },
              }}
            />
          </a>
          <FacebookIcon
            sx={{
              fontSize: 40,
              margin: "5px",
              color: "white",
              backgroundColor: "#316FF6",
              borderRadius: "10px",
              "&:hover": {
                backgroundColor: "white",
                color: "#316FF6",
                cursor: "pointer",
                borderRadius: "10px",
                border: "1px solid black",
              },
            }}
          />
  
          <div className="rain-effect-footer">{rainDrops}</div>
        </div>
  
      </footer>
      <p style={{color:"white",textAlign:"center",fontSize:"12px",padding:"12px",background:"#12151c"}}>

        {new Date().getFullYear()} © Eagle Villa. All rights reserved.
      </p>
    </div>
  );
};

export default Footer;
